// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.metrics {
    margin: 2px 8px;
}

.home-info {
    display: flex;
    padding: 5px 15px;
    justify-content: space-between;
    align-items: center;

    >h3 {
        color: var(--Black, #202226);
        font-family: Poppins;
        font-size: 15px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        /* 175% */
    }

    >p {
        color: var(--brand-primary, #0877BC);
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
        /* 157.143% */
    }
}



.card-info {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    text-align: left;
}

.metrics-container {
    padding: 0 5px;
}

.metrics-container .slideData h3 {
    color: color-mix(in srgb, var(--brand-primary, #0877BC) 65%, #1f2937);
    font-size: 13px;
    font-weight: 600;
    text-transform: none;
    letter-spacing: 0.02em;
    margin: 0 0 8px 0;
    line-height: 1.25;
    min-height: 2.5em;
    display: flex;
    align-items: center;
    word-break: break-word;
    hyphens: auto;
}

.metric-icon {
    height: 80px;
    width: 80px;
    margin: 0;
    border: 3px solid var(--brand-primary, #0877BC);
    border-radius: 50%;
    padding: 0;
    background: linear-gradient(135deg, var(--brand-primary, #0877BC) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 72%, #000) 100%);
    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 32%, transparent);
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
}

.metric-icon svg {
    font-size: 32px;
    color: white;
    z-index: 2;
    position: relative;
}

.slideData:hover .metric-icon {
    transform: scale(1.05);
    box-shadow: 0 6px 20px color-mix(in srgb, var(--brand-primary, #0877BC) 42%, transparent);
}

.slideData:hover .metric-icon svg {
    transform: scale(1.1);
}

/* Specific icon colors and gradients */
.players-icon {
    background: linear-gradient(145deg, var(--brand-primary, #0877BC) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 82%, #fff) 100%);
    border-color: var(--brand-primary, #0877BC);
    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 25%, transparent);
}

.women-icon {
    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 88%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 60%, #000) 100%);
    border-color: var(--brand-primary, #0877BC);
    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 25%, transparent);
}

.active-players-icon {
    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 78%, #fff) 0%, var(--brand-primary, #0877BC) 100%);
    border-color: var(--brand-primary, #0877BC);
    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 25%, transparent);
}

.coach-icon {
    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 60%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 75%, #000) 100%);
    border-color: var(--brand-primary, #0877BC);
    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 25%, transparent);
}

.groups-icon {
    background: linear-gradient(145deg, var(--brand-primary, #0877BC) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 55%, #000) 100%);
    border-color: var(--brand-primary, #0877BC);
    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 25%, transparent);
}

.sessions-icon {
    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 92%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 68%, #000) 100%);
    border-color: var(--brand-primary, #0877BC);
    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 25%, transparent);
}

.next-sessions-icon {
    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 82%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 58%, #000) 100%);
    border-color: var(--brand-primary, #0877BC);
    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 25%, transparent);
}


.slideData {
    display: flex;
    align-items: center;
    gap: 30px;
    background: linear-gradient(135deg, #fff 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 7%, #fff) 100%);
    border-radius: 16px;
    padding: 25px 20px;
    box-shadow: 0 8px 25px color-mix(in srgb, var(--brand-primary, #0877BC) 20%, transparent);
    margin: 15px 10px;
    background-color: #fff;
    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 22%, #fff);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    min-height: 148px;
    box-sizing: border-box;
}

.slideData:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 35px color-mix(in srgb, var(--brand-primary, #0877BC) 32%, transparent);
}

/* Ensure text stays readable on hover (theme-aware). */
.slideData:hover .card-info h3,
.slideData:hover .card-info p {
    color: inherit;
}

.home-theme-root .slideData:hover .card-info h3 {
    color: var(--text-secondary) !important;
}

.home-theme-root .slideData:hover .card-info p,
.home-theme-root .slideData:hover .card-info-main {
    color: var(--text-color) !important;
}

/* Specific hover effects for different metric types */
.slideData:hover .players-icon {
    background: linear-gradient(145deg, var(--brand-primary, #0877BC) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 75%, #000) 100%);
}

.slideData:hover .women-icon {
    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 88%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 62%, #000) 100%);
}

.slideData:hover .active-players-icon {
    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 78%, #fff) 0%, var(--brand-primary, #0877BC) 100%);
}

.slideData:hover .coach-icon {
    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 65%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 75%, #000) 100%);
}

.slideData:hover .groups-icon {
    background: linear-gradient(145deg, var(--brand-primary, #0877BC) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 55%, #000) 100%);
}

.slideData:hover .sessions-icon {
    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 92%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 68%, #000) 100%);
}

.slideData:hover .next-sessions-icon {
    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 82%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 58%, #000) 100%);
}

.slideData::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, var(--brand-primary, #0877BC) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 72%, #000) 100%);
}

.slideData p.card-info-main {
    font-size: 32px;
    color: #202226;
    font-family: Poppins-bold;
    font-weight: 700;
    margin: 0;
    line-height: 1;
}

.slideData p.card-info-unit {
    font-size: 14px;
    color: #838383;
    font-family: Poppins;
    margin-left: 5px;
    text-transform: capitalize;
}

.metrics-container .slideData p.update-date {
    font-size: 12px;
    color: #A2A5B1;
    font-family: Poppins;
}

.metrics-cards {
    padding: 0 15px;
    display: flex;
    gap: 11px;
    overflow-x: auto;
}

.metrics-cards::-webkit-scrollbar {
    height: 5px;
}

.metrics-cards::-webkit-scrollbar-track {
    border-radius: 10px;
}

.metrics-cards::-webkit-scrollbar-thumb {
    background: rgba(109, 109, 109, 0.425);
    border-radius: 10px;
}

.metrics-cards::-webkit-scrollbar-thumb:hover {
    background: rgba(109, 109, 109, 0.185);

}

.metric-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: 160px;
    padding: 20px;
    overflow: visible;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    border-radius: 16px;
    background: var(--White, #FFF);
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05);

    >h3 {
        color: var(--Black, #202226);
        text-align: center;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        /* 171.429% */
    }

    >p {
        color: var(--Gray-2, #A2A5B1);
        text-align: center;
        font-family: Poppins;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        /* 166.667% */
    }

    >.card-info {
        display: flex;
        align-items: baseline;

        >.card-info-main {
            color: var(--Black, #202226);
            text-align: center;
            /* Heading */
            font-family: Poppins;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: 28px;
            /* 140% */
        }

        >.card-info-unit {
            color: var(--Gray-1, #838383);
            /* Body/Regular */
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
        }
    }
}

.date_info {
    width: 350px;
    margin: 0 15px;
}

/* -------------------Grouplist---------------- */

.react-slideshow-container .nav:first-of-type {
    left: 0px !important;
    background: #f3f8fa;
    box-shadow: 1px 1px 10px 0px #053e6130;
    width: 25px;
    height: 25px;

}

.react-slideshow-container .default-nav:last-of-type {
    right: 0px !important;
    background: #f3f8fa;
    box-shadow: 2px 2px 10px 0px #053e6130;
    width: 25px;
    height: 25px;
}

.react-slideshow-container .nav:first-of-type svg,
.react-slideshow-container .default-nav:last-of-type svg {
    width: 9px;
    height: 9px;
    fill: var(--brand-primary, #0877BC);

}

.Groupcard {
    padding: 0;
    cursor: pointer;
    background: var(--surface-color, #fff);
    margin: 5px 10px;
    border-radius: 16px;
    box-shadow: 0 10px 28px color-mix(in srgb, var(--brand-primary, #0877BC) 14%, transparent);
    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 18%, var(--border-color, #e8eef3));
    position: relative;
    width: calc(100% / 3 - 20px);
    box-sizing: border-box;
    overflow: hidden;
    isolation: isolate;
    transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
}

.Groupcard::before {
    content: "";
    position: absolute;
    left: 0;
    top: 18px;
    bottom: 18px;
    width: 3px;
    border-radius: 0 3px 3px 0;
    background: color-mix(in srgb, var(--brand-primary, #0877BC) 35%, transparent);
    z-index: 3;
    opacity: 0.55;
    transition: top 0.22s ease, bottom 0.22s ease, opacity 0.22s ease;
}

.Groupcard:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 36px color-mix(in srgb, var(--brand-primary, #0877BC) 22%, transparent);
    border-color: color-mix(in srgb, var(--brand-primary, #0877BC) 42%, var(--border-color, #e8eef3));
}

.Groupcard:focus-visible {
    outline: 2px solid var(--brand-primary, #0877BC);
    outline-offset: 3px;
}

.Groupcard.selectedgrp,
.Groupcard.groupcard--selected {
    border-color: color-mix(in srgb, var(--brand-primary, #0877BC) 55%, var(--border-color, #e8eef3));
    box-shadow:
        0 14px 32px color-mix(in srgb, var(--brand-primary, #0877BC) 24%, transparent),
        inset 0 0 0 1px color-mix(in srgb, var(--brand-primary, #0877BC) 18%, transparent);
}

.Groupcard.selectedgrp::before,
.Groupcard.groupcard--selected::before {
    top: 8px;
    bottom: 8px;
    opacity: 1;
    background: var(--brand-primary, #0877BC);
    box-shadow: 0 0 12px color-mix(in srgb, var(--brand-primary, #0877BC) 55%, transparent);
}

/* Groups use the same lateral swipe Slide as metrics */
.groups-slider-container {
    padding: 0 5px 8px;
}

.groups-slider-container .groups-slide {
    outline: none;
}

.groups-slider-container .Groupcard {
    width: calc(100% - 16px);
    margin: 8px;
    height: 100%;
    box-sizing: border-box;
}

.groups-slider-container .react-slideshow-container,
.groups-slider-container .react-slideshow-fadezoom-wrapper,
.groups-slider-container .react-slideshow-wrapper,
.groups-slider-container .images-wrap {
    width: 100%;
}

.groups-slider-container .react-slideshow-container + .indicators {
    margin-top: 4px;
    padding-bottom: 4px;
}

@media (max-width: 640px) {
    .groups-slider-container .Groupcard {
        width: calc(100% - 12px);
        margin: 6px;
    }
}

.selectedgrp {
    border-width: 1px;
}

.ImageOverlay,
.groupcard__media {
    width: 100%;
    height: 118px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background:
        radial-gradient(120% 90% at 12% 110%, color-mix(in srgb, var(--brand-primary, #0877BC) 38%, transparent) 0%, transparent 58%),
        linear-gradient(165deg, color-mix(in srgb, var(--brand-primary, #0877BC) 22%, #0b1f33) 0%, #102a44 100%);
}

.groupcard__media::after {
    content: "";
    position: absolute;
    inset: auto 0 0 0;
    height: 42%;
    background: linear-gradient(to top, rgba(8, 18, 32, 0.62), transparent);
    pointer-events: none;
    z-index: 1;
}

.ImageOverlay img,
.groupcard__media img {
    width: 100%;
    height: 100%;
    border-radius: 0;
    transition: filter 0.6s ease-in-out, transform 0.35s ease;
    object-fit: cover;
}

.Groupcard:hover .groupcard__media img {
    transform: scale(1.04);
}

.ImageOverlay img.loading,
.groupcard__media img.loading {
    filter: blur(5px);
}

.ImageOverlay img.loaded,
.groupcard__media img.loaded {
    filter: none;
}

.groupcard__monogram.group_dummyimg {
    font-size: 42px;
    font-weight: 750;
    letter-spacing: 0.04em;
    color: #fff;
    text-shadow: 0 6px 18px rgba(0, 0, 0, 0.28);
}

/* + sits on the group card (body corner), not on the media / remaining plaque */
.groupcard__add-session {
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 5;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    min-width: 34px;
    padding: 0;
    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 35%, #fff);
    border-radius: 50%;
    background: var(--brand-primary, #0877BC);
    color: #fff;
    box-shadow: 0 4px 12px color-mix(in srgb, var(--brand-primary, #0877BC) 35%, transparent);
    cursor: pointer;
    font: inherit;
    font-size: 0.9rem;
    font-weight: 750;
    line-height: 1;
    -webkit-tap-highlight-color: transparent;
}

.groupcard__add-session:hover,
.groupcard__add-session:focus-visible {
    background: color-mix(in srgb, var(--brand-primary, #0877BC) 88%, #0b1220);
    outline: none;
    transform: scale(1.06);
}

.groupcard__add-session:active {
    transform: scale(0.94);
}

.groupcard__add-session-label {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

/* Remaining sessions badge — only on the media sub-card, top-right */
.groupcard__plaque {
    position: absolute;
    top: 8px;
    right: 8px;
    bottom: auto;
    z-index: 3;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    min-width: 48px;
    max-width: calc(100% - 20px);
    padding: 5px 8px 4px;
    border-radius: 8px;
    background: color-mix(in srgb, #0c1724 72%, transparent);
    border: 1px solid color-mix(in srgb, #fff 22%, transparent);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.28);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    color: #fff;
    line-height: 1;
    pointer-events: none;
}

.groupcard__plaque-num {
    font-size: 18px;
    font-weight: 750;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.03em;
}

.groupcard__plaque-lbl {
    margin-top: 2px;
    max-width: 96px;
    font-size: 8px;
    font-weight: 650;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    opacity: 0.85;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (max-width: 640px) {
    .groupcard__add-session {
        width: 36px;
        height: 36px;
        min-width: 36px;
        right: 12px;
        bottom: 12px;
        font-size: 0.95rem;
    }

    .groupcard__plaque {
        top: 10px;
        right: 10px;
    }
}

.groupcard__body.group_name {
    padding: 10px 48px 12px 16px;
    text-align: left;
}

.groupcard__body.group_name p {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: -0.02em;
    line-height: 1.25;
}

.groupcard__lanes {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-top: 10px;
}

.groupcard__lane {
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
    padding-top: 6px;
    border-top: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 16%, var(--border-color, #e8eef3));
}

.groupcard__lane-val {
    font-size: 16px;
    font-weight: 750;
    font-variant-numeric: tabular-nums;
    color: var(--text-color, #202226);
    letter-spacing: -0.03em;
}

.groupcard__lane-lbl {
    font-size: 10px;
    font-weight: 650;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--text-secondary, #6b7c8c);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* .blur-placeholder {
    width: 100%;
    height: 100%;
    background-color: #ccc;
    position: absolute;
    top: 0;
    left: 0;
} */

.blur-placeholder {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    filter: blur(80px);
    z-index: 1;
    border-radius: 8px;
}

.imageoverlay_div {
    display: none;
}

.group_overlay_details {
    padding: 2px;
    color: #fff;
    font-weight: 500;
    font-size: 12px;
    margin: 2px 5px;
}

@media (prefers-reduced-motion: reduce) {
    .Groupcard,
    .Groupcard::before,
    .Groupcard:hover .groupcard__media img {
        transition: none;
        transform: none;
    }
}

.slider-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    width: 100%;
    position: relative;

}

.slideInfoStyle {
    display: flex;
    flex-direction: column;
    background-size: cover;
    margin: 15px;

}

.sliderinfoheading {
    color: var(--brand-primary, #0877BC);
    font-size: 15px;
    font-weight: 600;

}

.sliderinfosheading {
    color: color-mix(in srgb, var(--brand-primary, #0877BC) 45%, #1f2937);
    font-size: 14px;

}

.sliderinfotheading {
    color: #59585b;
    font-size: 13px;

}

.slideInfoPStyle {
    font-size: 10px;
    color: #7c7a7a;
}

.slideInfoStrongStyle {
    margin-left: 9px
}

@media(max-width:900px) {
    .Groupcard {
        width: calc(50% - 20px)
    }

    .groups-slider-container .Groupcard {
        width: calc(100% - 16px);
    }

    .slideData {
        flex-direction: column;
        justify-content: center;
        gap: 15px;
        padding: 20px 15px;
        min-height: 160px;
    }

    .card-info {
        align-items: center;
        text-align: center;
    }

    .metric-icon {
        height: 60px;
        width: 60px;
    }

    .metric-icon svg {
        font-size: 24px;
    }

    .slideData p.card-info-main {
        font-size: 28px;
    }
}

@media(max-width:550px) {
    .Groupcard {
        width: 92%;
    }

    .groups-slider-container .Groupcard {
        width: calc(100% - 12px);
        margin: 6px;
    }

    .slideData {
        padding: 15px 10px;
        margin: 10px 5px;
        min-height: 150px;
    }

    .metric-icon {
        height: 50px;
        width: 50px;
    }

    .metric-icon svg {
        font-size: 20px;
    }

    .slideData p.card-info-main {
        font-size: 24px;
    }

    .metrics-container .slideData h3 {
        font-size: 12px;
    }
}

/* Compact home metrics strip — horizontal snap carousel (3 per snap) */
.metrics-compact {
    margin: 2px 8px 6px;
}

.metrics-compact__carousel {
    padding: 0 2px 4px;
}

.metrics-compact__carousel .react-slideshow-container,
.metrics-compact__carousel .react-slideshow-fadezoom-wrapper,
.metrics-compact__carousel .react-slideshow-wrapper,
.metrics-compact__carousel .images-wrap {
    width: 100%;
}

.metrics-compact__carousel .react-slideshow-container + .indicators {
    margin-top: 2px;
    padding-bottom: 2px;
    display: flex;
    justify-content: center;
    gap: 4px;
}

.metrics-compact__carousel .indicators .each-slideshow-indicator {
    cursor: pointer;
}

.metrics-compact__carousel .indicators .each-slideshow-indicator::before {
    background: color-mix(in srgb, var(--brand-primary, #0877BC) 35%, #cbd5e1) !important;
}

.metrics-compact__carousel .indicators .each-slideshow-indicator.active::before {
    background: var(--brand-primary, #0877BC) !important;
}

.metrics-compact__slide {
    outline: none;
    padding: 0 3px;
    box-sizing: border-box;
    width: 100%;
}

.metrics-compact-slideshow .images-wrap > div {
    display: flex !important;
    align-items: stretch;
}

.metrics-compact__cell {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
    width: 100%;
    min-height: 52px;
    height: 100%;
    padding: 8px 8px;
    border-radius: 12px;
    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 16%, var(--border-color, rgba(0, 0, 0, 0.08)));
    background:
        linear-gradient(
            145deg,
            color-mix(in srgb, var(--brand-primary, #0877BC) 8%, transparent) 0%,
            transparent 70%
        ),
        var(--surface-color, #fff);
    box-shadow: 0 2px 8px color-mix(in srgb, var(--brand-primary, #0877BC) 8%, transparent);
    box-sizing: border-box;
}

.metrics-compact__icon {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #fff;
    background: var(--brand-primary, #0877BC);
}

.metrics-compact__cell--sessions .metrics-compact__icon {
    background: color-mix(in srgb, var(--brand-primary, #0877BC) 78%, #0f766e);
}

.metrics-compact__cell--players .metrics-compact__icon {
    background: color-mix(in srgb, var(--brand-primary, #0877BC) 70%, #b45309);
}

.metrics-compact__cell--upcoming .metrics-compact__icon {
    background: color-mix(in srgb, var(--brand-primary, #0877BC) 65%, #6d28d9);
}

.metrics-compact__copy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0;
    line-height: 1.15;
}

.metrics-compact__value {
    margin: 0 !important;
    font-size: 1.05rem !important;
    font-weight: 750 !important;
    letter-spacing: -0.02em;
    color: var(--text-color, #111) !important;
    line-height: 1.1 !important;
}

.metrics-compact__label {
    margin: 0 !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    color: var(--text-secondary, #64748b) !important;
    line-height: 1.2 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

@media (max-width: 640px) {
    .metrics-compact__slide {
        padding: 0 2px;
    }

    .metrics-compact__cell {
        padding: 7px 8px;
        gap: 6px;
    }

    .metrics-compact__icon {
        width: 24px;
        height: 24px;
        font-size: 11px;
        border-radius: 7px;
    }

    .metrics-compact__value {
        font-size: 0.95rem !important;
    }

    .metrics-compact__label {
        font-size: 9px !important;
        white-space: normal;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
}

.dark-mode .metrics-compact__cell,
html.dark-mode .metrics-compact__cell {
    background:
        linear-gradient(
            145deg,
            color-mix(in srgb, var(--brand-primary, #0877BC) 14%, transparent) 0%,
            transparent 70%
        ),
        var(--surface-color, #1a1a1a);
}`, "",{"version":3,"sources":["webpack://./src/components/Metric.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;;IAEnB;QACI,4BAA4B;QAC5B,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,oCAAoC;QACpC,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,aAAa;IACjB;AACJ;;;;AAIA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qEAAqE;IACrE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,SAAS;IACT,+CAA+C;IAC/C,kBAAkB;IAClB,UAAU;IACV,uIAAuI;IACvI,yFAAyF;IACzF,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,yFAAyF;AAC7F;;AAEA;IACI,qBAAqB;AACzB;;AAEA,uCAAuC;AACvC;IACI,uIAAuI;IACvI,2CAA2C;IAC3C,yFAAyF;AAC7F;;AAEA;IACI,qKAAqK;IACrK,2CAA2C;IAC3C,yFAAyF;AAC7F;;AAEA;IACI,uIAAuI;IACvI,2CAA2C;IAC3C,yFAAyF;AAC7F;;AAEA;IACI,qKAAqK;IACrK,2CAA2C;IAC3C,yFAAyF;AAC7F;;AAEA;IACI,uIAAuI;IACvI,2CAA2C;IAC3C,yFAAyF;AAC7F;;AAEA;IACI,qKAAqK;IACrK,2CAA2C;IAC3C,yFAAyF;AAC7F;;AAEA;IACI,qKAAqK;IACrK,2CAA2C;IAC3C,yFAAyF;AAC7F;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,6GAA6G;IAC7G,mBAAmB;IACnB,kBAAkB;IAClB,yFAAyF;IACzF,iBAAiB;IACjB,sBAAsB;IACtB,6EAA6E;IAC7E,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,0FAA0F;AAC9F;;AAEA,uDAAuD;AACvD;;IAEI,cAAc;AAClB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA,sDAAsD;AACtD;IACI,uIAAuI;AAC3I;;AAEA;IACI,qKAAqK;AACzK;;AAEA;IACI,uIAAuI;AAC3I;;AAEA;IACI,qKAAqK;AACzK;;AAEA;IACI,uIAAuI;AAC3I;;AAEA;IACI,qKAAqK;AACzK;;AAEA;IACI,qKAAqK;AACzK;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,sIAAsI;AAC1I;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;;AAE1C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,8BAA8B;IAC9B,gDAAgD;;IAEhD;QACI,4BAA4B;QAC5B,kBAAkB;QAClB,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,qBAAqB;;QAErB;YACI,4BAA4B;YAC5B,kBAAkB;YAClB,YAAY;YACZ,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,SAAS;QACb;;QAEA;YACI,6BAA6B;YAC7B,iBAAiB;YACjB,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;QACrB;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA,iDAAiD;;AAEjD;IACI,oBAAoB;IACpB,mBAAmB;IACnB,sCAAsC;IACtC,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sCAAsC;IACtC,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,mCAAmC;;AAEvC;;AAEA;IACI,UAAU;IACV,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,mBAAmB;IACnB,0FAA0F;IAC1F,qGAAqG;IACrG,kBAAkB;IAClB,4BAA4B;IAC5B,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,gFAAgF;AACpF;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,YAAY;IACZ,UAAU;IACV,0BAA0B;IAC1B,8EAA8E;IAC9E,UAAU;IACV,aAAa;IACb,iEAAiE;AACrE;;AAEA;IACI,2BAA2B;IAC3B,0FAA0F;IAC1F,iGAAiG;AACrG;;AAEA;IACI,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA;;IAEI,iGAAiG;IACjG;;0FAEsF;AAC1F;;AAEA;;IAEI,QAAQ;IACR,WAAW;IACX,UAAU;IACV,yCAAyC;IACzC,uFAAuF;AAC3F;;AAEA,uDAAuD;AACvD;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;;;;IAII,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI;QACI,wBAAwB;QACxB,WAAW;IACf;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB;;gHAE4G;AAChH;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,uEAAuE;IACvE,oBAAoB;IACpB,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yDAAyD;IACzD,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,2CAA2C;AAC/C;;AAEA,gFAAgF;AAChF;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,6EAA6E;IAC7E,kBAAkB;IAClB,yCAAyC;IACzC,WAAW;IACX,yFAAyF;IACzF,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;;IAEI,0EAA0E;IAC1E,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA,qEAAqE;AACrE;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,4BAA4B;IAC5B,oBAAoB;IACpB,kBAAkB;IAClB,wDAAwD;IACxD,2DAA2D;IAC3D,0CAA0C;IAC1C,2BAA2B;IAC3B,mCAAmC;IACnC,WAAW;IACX,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,SAAS;QACT,WAAW;IACf;AACJ;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,yGAAyG;AAC7G;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;;;;;;GAOG;;AAEH;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI;;;QAGI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;;AAEhB;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI,qEAAqE;IACrE,eAAe;;AAEnB;;AAEA;IACI,cAAc;IACd,eAAe;;AAEnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,uEAAuE;AACvE;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;;IAII,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qFAAqF;AACzF;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,iHAAiH;IACjH;;;;;;kCAM8B;IAC9B,uFAAuF;IACvF,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,0EAA0E;AAC9E;;AAEA;IACI,0EAA0E;AAC9E;;AAEA;IACI,0EAA0E;AAC9E;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,6BAA6B;IAC7B,2BAA2B;IAC3B,uBAAuB;IACvB,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;IAC3B,gDAAgD;IAChD,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB,oBAAoB;QACpB,qBAAqB;QACrB,4BAA4B;IAChC;AACJ;;AAEA;;IAEI;;;;;;qCAMiC;AACrC","sourcesContent":[".metrics {\n    margin: 2px 8px;\n}\n\n.home-info {\n    display: flex;\n    padding: 5px 15px;\n    justify-content: space-between;\n    align-items: center;\n\n    >h3 {\n        color: var(--Black, #202226);\n        font-family: Poppins;\n        font-size: 15px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 28px;\n        /* 175% */\n    }\n\n    >p {\n        color: var(--brand-primary, #0877BC);\n        font-family: Poppins;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 22px;\n        /* 157.143% */\n    }\n}\n\n\n\n.card-info {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    text-align: left;\n}\n\n.metrics-container {\n    padding: 0 5px;\n}\n\n.metrics-container .slideData h3 {\n    color: color-mix(in srgb, var(--brand-primary, #0877BC) 65%, #1f2937);\n    font-size: 13px;\n    font-weight: 600;\n    text-transform: none;\n    letter-spacing: 0.02em;\n    margin: 0 0 8px 0;\n    line-height: 1.25;\n    min-height: 2.5em;\n    display: flex;\n    align-items: center;\n    word-break: break-word;\n    hyphens: auto;\n}\n\n.metric-icon {\n    height: 80px;\n    width: 80px;\n    margin: 0;\n    border: 3px solid var(--brand-primary, #0877BC);\n    border-radius: 50%;\n    padding: 0;\n    background: linear-gradient(135deg, var(--brand-primary, #0877BC) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 72%, #000) 100%);\n    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 32%, transparent);\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    overflow: hidden;\n}\n\n.metric-icon svg {\n    font-size: 32px;\n    color: white;\n    z-index: 2;\n    position: relative;\n}\n\n.slideData:hover .metric-icon {\n    transform: scale(1.05);\n    box-shadow: 0 6px 20px color-mix(in srgb, var(--brand-primary, #0877BC) 42%, transparent);\n}\n\n.slideData:hover .metric-icon svg {\n    transform: scale(1.1);\n}\n\n/* Specific icon colors and gradients */\n.players-icon {\n    background: linear-gradient(145deg, var(--brand-primary, #0877BC) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 82%, #fff) 100%);\n    border-color: var(--brand-primary, #0877BC);\n    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 25%, transparent);\n}\n\n.women-icon {\n    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 88%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 60%, #000) 100%);\n    border-color: var(--brand-primary, #0877BC);\n    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 25%, transparent);\n}\n\n.active-players-icon {\n    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 78%, #fff) 0%, var(--brand-primary, #0877BC) 100%);\n    border-color: var(--brand-primary, #0877BC);\n    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 25%, transparent);\n}\n\n.coach-icon {\n    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 60%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 75%, #000) 100%);\n    border-color: var(--brand-primary, #0877BC);\n    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 25%, transparent);\n}\n\n.groups-icon {\n    background: linear-gradient(145deg, var(--brand-primary, #0877BC) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 55%, #000) 100%);\n    border-color: var(--brand-primary, #0877BC);\n    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 25%, transparent);\n}\n\n.sessions-icon {\n    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 92%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 68%, #000) 100%);\n    border-color: var(--brand-primary, #0877BC);\n    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 25%, transparent);\n}\n\n.next-sessions-icon {\n    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 82%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 58%, #000) 100%);\n    border-color: var(--brand-primary, #0877BC);\n    box-shadow: 0 4px 15px color-mix(in srgb, var(--brand-primary, #0877BC) 25%, transparent);\n}\n\n\n.slideData {\n    display: flex;\n    align-items: center;\n    gap: 30px;\n    background: linear-gradient(135deg, #fff 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 7%, #fff) 100%);\n    border-radius: 16px;\n    padding: 25px 20px;\n    box-shadow: 0 8px 25px color-mix(in srgb, var(--brand-primary, #0877BC) 20%, transparent);\n    margin: 15px 10px;\n    background-color: #fff;\n    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 22%, #fff);\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n    min-height: 148px;\n    box-sizing: border-box;\n}\n\n.slideData:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 12px 35px color-mix(in srgb, var(--brand-primary, #0877BC) 32%, transparent);\n}\n\n/* Ensure text stays readable on hover (theme-aware). */\n.slideData:hover .card-info h3,\n.slideData:hover .card-info p {\n    color: inherit;\n}\n\n.home-theme-root .slideData:hover .card-info h3 {\n    color: var(--text-secondary) !important;\n}\n\n.home-theme-root .slideData:hover .card-info p,\n.home-theme-root .slideData:hover .card-info-main {\n    color: var(--text-color) !important;\n}\n\n/* Specific hover effects for different metric types */\n.slideData:hover .players-icon {\n    background: linear-gradient(145deg, var(--brand-primary, #0877BC) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 75%, #000) 100%);\n}\n\n.slideData:hover .women-icon {\n    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 88%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 62%, #000) 100%);\n}\n\n.slideData:hover .active-players-icon {\n    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 78%, #fff) 0%, var(--brand-primary, #0877BC) 100%);\n}\n\n.slideData:hover .coach-icon {\n    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 65%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 75%, #000) 100%);\n}\n\n.slideData:hover .groups-icon {\n    background: linear-gradient(145deg, var(--brand-primary, #0877BC) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 55%, #000) 100%);\n}\n\n.slideData:hover .sessions-icon {\n    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 92%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 68%, #000) 100%);\n}\n\n.slideData:hover .next-sessions-icon {\n    background: linear-gradient(145deg, color-mix(in srgb, var(--brand-primary, #0877BC) 82%, #fff) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 58%, #000) 100%);\n}\n\n.slideData::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background: linear-gradient(90deg, var(--brand-primary, #0877BC) 0%, color-mix(in srgb, var(--brand-primary, #0877BC) 72%, #000) 100%);\n}\n\n.slideData p.card-info-main {\n    font-size: 32px;\n    color: #202226;\n    font-family: Poppins-bold;\n    font-weight: 700;\n    margin: 0;\n    line-height: 1;\n}\n\n.slideData p.card-info-unit {\n    font-size: 14px;\n    color: #838383;\n    font-family: Poppins;\n    margin-left: 5px;\n    text-transform: capitalize;\n}\n\n.metrics-container .slideData p.update-date {\n    font-size: 12px;\n    color: #A2A5B1;\n    font-family: Poppins;\n}\n\n.metrics-cards {\n    padding: 0 15px;\n    display: flex;\n    gap: 11px;\n    overflow-x: auto;\n}\n\n.metrics-cards::-webkit-scrollbar {\n    height: 5px;\n}\n\n.metrics-cards::-webkit-scrollbar-track {\n    border-radius: 10px;\n}\n\n.metrics-cards::-webkit-scrollbar-thumb {\n    background: rgba(109, 109, 109, 0.425);\n    border-radius: 10px;\n}\n\n.metrics-cards::-webkit-scrollbar-thumb:hover {\n    background: rgba(109, 109, 109, 0.185);\n\n}\n\n.metric-card {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    min-width: 160px;\n    padding: 20px;\n    overflow: visible;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    border-radius: 16px;\n    background: var(--White, #FFF);\n    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05);\n\n    >h3 {\n        color: var(--Black, #202226);\n        text-align: center;\n        font-family: Poppins;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 24px;\n        /* 171.429% */\n    }\n\n    >p {\n        color: var(--Gray-2, #A2A5B1);\n        text-align: center;\n        font-family: Poppins;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 20px;\n        /* 166.667% */\n    }\n\n    >.card-info {\n        display: flex;\n        align-items: baseline;\n\n        >.card-info-main {\n            color: var(--Black, #202226);\n            text-align: center;\n            /* Heading */\n            font-family: Poppins;\n            font-size: 20px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 28px;\n            /* 140% */\n        }\n\n        >.card-info-unit {\n            color: var(--Gray-1, #838383);\n            /* Body/Regular */\n            font-family: Poppins;\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 24px;\n        }\n    }\n}\n\n.date_info {\n    width: 350px;\n    margin: 0 15px;\n}\n\n/* -------------------Grouplist---------------- */\n\n.react-slideshow-container .nav:first-of-type {\n    left: 0px !important;\n    background: #f3f8fa;\n    box-shadow: 1px 1px 10px 0px #053e6130;\n    width: 25px;\n    height: 25px;\n\n}\n\n.react-slideshow-container .default-nav:last-of-type {\n    right: 0px !important;\n    background: #f3f8fa;\n    box-shadow: 2px 2px 10px 0px #053e6130;\n    width: 25px;\n    height: 25px;\n}\n\n.react-slideshow-container .nav:first-of-type svg,\n.react-slideshow-container .default-nav:last-of-type svg {\n    width: 9px;\n    height: 9px;\n    fill: var(--brand-primary, #0877BC);\n\n}\n\n.Groupcard {\n    padding: 0;\n    cursor: pointer;\n    background: var(--surface-color, #fff);\n    margin: 5px 10px;\n    border-radius: 16px;\n    box-shadow: 0 10px 28px color-mix(in srgb, var(--brand-primary, #0877BC) 14%, transparent);\n    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 18%, var(--border-color, #e8eef3));\n    position: relative;\n    width: calc(100% / 3 - 20px);\n    box-sizing: border-box;\n    overflow: hidden;\n    isolation: isolate;\n    transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;\n}\n\n.Groupcard::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 18px;\n    bottom: 18px;\n    width: 3px;\n    border-radius: 0 3px 3px 0;\n    background: color-mix(in srgb, var(--brand-primary, #0877BC) 35%, transparent);\n    z-index: 3;\n    opacity: 0.55;\n    transition: top 0.22s ease, bottom 0.22s ease, opacity 0.22s ease;\n}\n\n.Groupcard:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 16px 36px color-mix(in srgb, var(--brand-primary, #0877BC) 22%, transparent);\n    border-color: color-mix(in srgb, var(--brand-primary, #0877BC) 42%, var(--border-color, #e8eef3));\n}\n\n.Groupcard:focus-visible {\n    outline: 2px solid var(--brand-primary, #0877BC);\n    outline-offset: 3px;\n}\n\n.Groupcard.selectedgrp,\n.Groupcard.groupcard--selected {\n    border-color: color-mix(in srgb, var(--brand-primary, #0877BC) 55%, var(--border-color, #e8eef3));\n    box-shadow:\n        0 14px 32px color-mix(in srgb, var(--brand-primary, #0877BC) 24%, transparent),\n        inset 0 0 0 1px color-mix(in srgb, var(--brand-primary, #0877BC) 18%, transparent);\n}\n\n.Groupcard.selectedgrp::before,\n.Groupcard.groupcard--selected::before {\n    top: 8px;\n    bottom: 8px;\n    opacity: 1;\n    background: var(--brand-primary, #0877BC);\n    box-shadow: 0 0 12px color-mix(in srgb, var(--brand-primary, #0877BC) 55%, transparent);\n}\n\n/* Groups use the same lateral swipe Slide as metrics */\n.groups-slider-container {\n    padding: 0 5px 8px;\n}\n\n.groups-slider-container .groups-slide {\n    outline: none;\n}\n\n.groups-slider-container .Groupcard {\n    width: calc(100% - 16px);\n    margin: 8px;\n    height: 100%;\n    box-sizing: border-box;\n}\n\n.groups-slider-container .react-slideshow-container,\n.groups-slider-container .react-slideshow-fadezoom-wrapper,\n.groups-slider-container .react-slideshow-wrapper,\n.groups-slider-container .images-wrap {\n    width: 100%;\n}\n\n.groups-slider-container .react-slideshow-container + .indicators {\n    margin-top: 4px;\n    padding-bottom: 4px;\n}\n\n@media (max-width: 640px) {\n    .groups-slider-container .Groupcard {\n        width: calc(100% - 12px);\n        margin: 6px;\n    }\n}\n\n.selectedgrp {\n    border-width: 1px;\n}\n\n.ImageOverlay,\n.groupcard__media {\n    width: 100%;\n    height: 118px;\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    background:\n        radial-gradient(120% 90% at 12% 110%, color-mix(in srgb, var(--brand-primary, #0877BC) 38%, transparent) 0%, transparent 58%),\n        linear-gradient(165deg, color-mix(in srgb, var(--brand-primary, #0877BC) 22%, #0b1f33) 0%, #102a44 100%);\n}\n\n.groupcard__media::after {\n    content: \"\";\n    position: absolute;\n    inset: auto 0 0 0;\n    height: 42%;\n    background: linear-gradient(to top, rgba(8, 18, 32, 0.62), transparent);\n    pointer-events: none;\n    z-index: 1;\n}\n\n.ImageOverlay img,\n.groupcard__media img {\n    width: 100%;\n    height: 100%;\n    border-radius: 0;\n    transition: filter 0.6s ease-in-out, transform 0.35s ease;\n    object-fit: cover;\n}\n\n.Groupcard:hover .groupcard__media img {\n    transform: scale(1.04);\n}\n\n.ImageOverlay img.loading,\n.groupcard__media img.loading {\n    filter: blur(5px);\n}\n\n.ImageOverlay img.loaded,\n.groupcard__media img.loaded {\n    filter: none;\n}\n\n.groupcard__monogram.group_dummyimg {\n    font-size: 42px;\n    font-weight: 750;\n    letter-spacing: 0.04em;\n    color: #fff;\n    text-shadow: 0 6px 18px rgba(0, 0, 0, 0.28);\n}\n\n/* + sits on the group card (body corner), not on the media / remaining plaque */\n.groupcard__add-session {\n    position: absolute;\n    right: 10px;\n    bottom: 10px;\n    z-index: 5;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n    min-width: 34px;\n    padding: 0;\n    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 35%, #fff);\n    border-radius: 50%;\n    background: var(--brand-primary, #0877BC);\n    color: #fff;\n    box-shadow: 0 4px 12px color-mix(in srgb, var(--brand-primary, #0877BC) 35%, transparent);\n    cursor: pointer;\n    font: inherit;\n    font-size: 0.9rem;\n    font-weight: 750;\n    line-height: 1;\n    -webkit-tap-highlight-color: transparent;\n}\n\n.groupcard__add-session:hover,\n.groupcard__add-session:focus-visible {\n    background: color-mix(in srgb, var(--brand-primary, #0877BC) 88%, #0b1220);\n    outline: none;\n    transform: scale(1.06);\n}\n\n.groupcard__add-session:active {\n    transform: scale(0.94);\n}\n\n.groupcard__add-session-label {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n}\n\n/* Remaining sessions badge — only on the media sub-card, top-right */\n.groupcard__plaque {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    bottom: auto;\n    z-index: 3;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    min-width: 48px;\n    max-width: calc(100% - 20px);\n    padding: 5px 8px 4px;\n    border-radius: 8px;\n    background: color-mix(in srgb, #0c1724 72%, transparent);\n    border: 1px solid color-mix(in srgb, #fff 22%, transparent);\n    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.28);\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    color: #fff;\n    line-height: 1;\n    pointer-events: none;\n}\n\n.groupcard__plaque-num {\n    font-size: 18px;\n    font-weight: 750;\n    font-variant-numeric: tabular-nums;\n    letter-spacing: -0.03em;\n}\n\n.groupcard__plaque-lbl {\n    margin-top: 2px;\n    max-width: 96px;\n    font-size: 8px;\n    font-weight: 650;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    opacity: 0.85;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n@media (max-width: 640px) {\n    .groupcard__add-session {\n        width: 36px;\n        height: 36px;\n        min-width: 36px;\n        right: 12px;\n        bottom: 12px;\n        font-size: 0.95rem;\n    }\n\n    .groupcard__plaque {\n        top: 10px;\n        right: 10px;\n    }\n}\n\n.groupcard__body.group_name {\n    padding: 10px 48px 12px 16px;\n    text-align: left;\n}\n\n.groupcard__body.group_name p {\n    font-size: 15px;\n    font-weight: 700;\n    letter-spacing: -0.02em;\n    line-height: 1.25;\n}\n\n.groupcard__lanes {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n    margin-top: 10px;\n}\n\n.groupcard__lane {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n    min-width: 0;\n    padding-top: 6px;\n    border-top: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 16%, var(--border-color, #e8eef3));\n}\n\n.groupcard__lane-val {\n    font-size: 16px;\n    font-weight: 750;\n    font-variant-numeric: tabular-nums;\n    color: var(--text-color, #202226);\n    letter-spacing: -0.03em;\n}\n\n.groupcard__lane-lbl {\n    font-size: 10px;\n    font-weight: 650;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: var(--text-secondary, #6b7c8c);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* .blur-placeholder {\n    width: 100%;\n    height: 100%;\n    background-color: #ccc;\n    position: absolute;\n    top: 0;\n    left: 0;\n} */\n\n.blur-placeholder {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    filter: blur(80px);\n    z-index: 1;\n    border-radius: 8px;\n}\n\n.imageoverlay_div {\n    display: none;\n}\n\n.group_overlay_details {\n    padding: 2px;\n    color: #fff;\n    font-weight: 500;\n    font-size: 12px;\n    margin: 2px 5px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .Groupcard,\n    .Groupcard::before,\n    .Groupcard:hover .groupcard__media img {\n        transition: none;\n        transform: none;\n    }\n}\n\n.slider-container {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    overflow: hidden;\n    width: 100%;\n    position: relative;\n\n}\n\n.slideInfoStyle {\n    display: flex;\n    flex-direction: column;\n    background-size: cover;\n    margin: 15px;\n\n}\n\n.sliderinfoheading {\n    color: var(--brand-primary, #0877BC);\n    font-size: 15px;\n    font-weight: 600;\n\n}\n\n.sliderinfosheading {\n    color: color-mix(in srgb, var(--brand-primary, #0877BC) 45%, #1f2937);\n    font-size: 14px;\n\n}\n\n.sliderinfotheading {\n    color: #59585b;\n    font-size: 13px;\n\n}\n\n.slideInfoPStyle {\n    font-size: 10px;\n    color: #7c7a7a;\n}\n\n.slideInfoStrongStyle {\n    margin-left: 9px\n}\n\n@media(max-width:900px) {\n    .Groupcard {\n        width: calc(50% - 20px)\n    }\n\n    .groups-slider-container .Groupcard {\n        width: calc(100% - 16px);\n    }\n\n    .slideData {\n        flex-direction: column;\n        justify-content: center;\n        gap: 15px;\n        padding: 20px 15px;\n        min-height: 160px;\n    }\n\n    .card-info {\n        align-items: center;\n        text-align: center;\n    }\n\n    .metric-icon {\n        height: 60px;\n        width: 60px;\n    }\n\n    .metric-icon svg {\n        font-size: 24px;\n    }\n\n    .slideData p.card-info-main {\n        font-size: 28px;\n    }\n}\n\n@media(max-width:550px) {\n    .Groupcard {\n        width: 92%;\n    }\n\n    .groups-slider-container .Groupcard {\n        width: calc(100% - 12px);\n        margin: 6px;\n    }\n\n    .slideData {\n        padding: 15px 10px;\n        margin: 10px 5px;\n        min-height: 150px;\n    }\n\n    .metric-icon {\n        height: 50px;\n        width: 50px;\n    }\n\n    .metric-icon svg {\n        font-size: 20px;\n    }\n\n    .slideData p.card-info-main {\n        font-size: 24px;\n    }\n\n    .metrics-container .slideData h3 {\n        font-size: 12px;\n    }\n}\n\n/* Compact home metrics strip — horizontal snap carousel (3 per snap) */\n.metrics-compact {\n    margin: 2px 8px 6px;\n}\n\n.metrics-compact__carousel {\n    padding: 0 2px 4px;\n}\n\n.metrics-compact__carousel .react-slideshow-container,\n.metrics-compact__carousel .react-slideshow-fadezoom-wrapper,\n.metrics-compact__carousel .react-slideshow-wrapper,\n.metrics-compact__carousel .images-wrap {\n    width: 100%;\n}\n\n.metrics-compact__carousel .react-slideshow-container + .indicators {\n    margin-top: 2px;\n    padding-bottom: 2px;\n    display: flex;\n    justify-content: center;\n    gap: 4px;\n}\n\n.metrics-compact__carousel .indicators .each-slideshow-indicator {\n    cursor: pointer;\n}\n\n.metrics-compact__carousel .indicators .each-slideshow-indicator::before {\n    background: color-mix(in srgb, var(--brand-primary, #0877BC) 35%, #cbd5e1) !important;\n}\n\n.metrics-compact__carousel .indicators .each-slideshow-indicator.active::before {\n    background: var(--brand-primary, #0877BC) !important;\n}\n\n.metrics-compact__slide {\n    outline: none;\n    padding: 0 3px;\n    box-sizing: border-box;\n    width: 100%;\n}\n\n.metrics-compact-slideshow .images-wrap > div {\n    display: flex !important;\n    align-items: stretch;\n}\n\n.metrics-compact__cell {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n    width: 100%;\n    min-height: 52px;\n    height: 100%;\n    padding: 8px 8px;\n    border-radius: 12px;\n    border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 16%, var(--border-color, rgba(0, 0, 0, 0.08)));\n    background:\n        linear-gradient(\n            145deg,\n            color-mix(in srgb, var(--brand-primary, #0877BC) 8%, transparent) 0%,\n            transparent 70%\n        ),\n        var(--surface-color, #fff);\n    box-shadow: 0 2px 8px color-mix(in srgb, var(--brand-primary, #0877BC) 8%, transparent);\n    box-sizing: border-box;\n}\n\n.metrics-compact__icon {\n    flex-shrink: 0;\n    width: 28px;\n    height: 28px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    color: #fff;\n    background: var(--brand-primary, #0877BC);\n}\n\n.metrics-compact__cell--sessions .metrics-compact__icon {\n    background: color-mix(in srgb, var(--brand-primary, #0877BC) 78%, #0f766e);\n}\n\n.metrics-compact__cell--players .metrics-compact__icon {\n    background: color-mix(in srgb, var(--brand-primary, #0877BC) 70%, #b45309);\n}\n\n.metrics-compact__cell--upcoming .metrics-compact__icon {\n    background: color-mix(in srgb, var(--brand-primary, #0877BC) 65%, #6d28d9);\n}\n\n.metrics-compact__copy {\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    line-height: 1.15;\n}\n\n.metrics-compact__value {\n    margin: 0 !important;\n    font-size: 1.05rem !important;\n    font-weight: 750 !important;\n    letter-spacing: -0.02em;\n    color: var(--text-color, #111) !important;\n    line-height: 1.1 !important;\n}\n\n.metrics-compact__label {\n    margin: 0 !important;\n    font-size: 10px !important;\n    font-weight: 600 !important;\n    color: var(--text-secondary, #64748b) !important;\n    line-height: 1.2 !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n@media (max-width: 640px) {\n    .metrics-compact__slide {\n        padding: 0 2px;\n    }\n\n    .metrics-compact__cell {\n        padding: 7px 8px;\n        gap: 6px;\n    }\n\n    .metrics-compact__icon {\n        width: 24px;\n        height: 24px;\n        font-size: 11px;\n        border-radius: 7px;\n    }\n\n    .metrics-compact__value {\n        font-size: 0.95rem !important;\n    }\n\n    .metrics-compact__label {\n        font-size: 9px !important;\n        white-space: normal;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n    }\n}\n\n.dark-mode .metrics-compact__cell,\nhtml.dark-mode .metrics-compact__cell {\n    background:\n        linear-gradient(\n            145deg,\n            color-mix(in srgb, var(--brand-primary, #0877BC) 14%, transparent) 0%,\n            transparent 70%\n        ),\n        var(--surface-color, #1a1a1a);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
